import React from 'react'
import { Box } from "grommet"
import { useTTUSAccount } from '../../utils/account'
import Mermaid from '../common/mermaid'

export const AppDataGraphAccount = ({ accountId }) => {

    const accountLookup = useTTUSAccount()
    //const accountParentLookup = useTTUSParentAccount()

    const getParentList = (accountId) => {
        if (!accountId || !accountLookup[accountId]) return []
        let parentList = getParentList(accountLookup[accountId].parentId)
        parentList.push(accountId)
        return parentList
    }

    let parent_list = []
    if (Object.keys(accountLookup).length > 0 && accountLookup[accountId] && accountLookup[accountId].parentId) {
        parent_list = getParentList(accountLookup[accountId].parentId)
    }

    // Draw Current Account
    let acc = accountId + '((' + accountId + ')); '
    acc += 'style ' + accountId + ' fill:#4682B4,stroke:#333,stroke-width:2px,color:white; '

    // Draw Parents
    if (parent_list.length > 0 ){
        let current = accountId
        parent_list.reverse().forEach(i => {
            acc += i + `[` + i + `] --> ` + current + '; '
            acc += 'style ' + i + ' fill:#BDD5EA,stroke:#333,stroke-width:2px; '
            current = i
        });
    }

    const accountTree = acc

    return (
        <Box
            name="account_hierarchy"
            flex={false}
            fill="horizontal"
            background='light-2'
            pad="xxsmall" gap="small"
        >

            {accountTree &&
                <Mermaid id="account_hierarchy" content={`graph LR;` + accountTree} envSelected={accountTree} />
            }

        </Box>
    )
}

export default AppDataGraphAccount
